<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" (click)="closeModal()"></ion-back-button>
    </ion-buttons>
    <ion-title>Bearbeiter & Beobachter</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" [scrollY]="canScroll">


  <h1>Bearbeiter & Beobachter</h1>
  <p>Weisen Sie Personen/Gruppen als Bearbeiter oder Beobachter zu. Sie können diese per Drag & Drop auch verschieben.</p>

  <div id="activeItems">
    <div id="editor-sec" class="item-col">
      <h2 style="margin-top: 10px;">Bearbeiter</h2>
      <p class="no-items" *ngIf="activeGroupes.length == 0 && activeEmployees.length == 0">Keine Bearbeiter</p>
      <div class="active-item" [attr.data-isobserver]="false"  [attr.data-isgroup]="true" [attr.data-groupid]="group.id" *ngFor="let group of activeGroupes" style="background: rgba(var(--blueRGB), 0.1)">
        <div>
          <ion-icon name="fa-user-group"></ion-icon>
          <div>{{group?.description}}</div>
        </div>
        <div class="c-bttn" (click)="workerTicket.checkEmployeeGroupe(group.id, false)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
      <div class="active-item" [attr.data-isobserver]="false"  [attr.data-employeeid]="employee.id" *ngFor="let employee of activeEmployees" style="background: rgba(var(--blueRGB), 0.2)">
        <div>
          <ion-icon name="fa-user"></ion-icon>
          <div>{{employee?.firstName}} {{employee?.lastName}} </div>
        </div>
        <div class="c-bttn" (click)="workerTicket.checkEmployee(employee.id, false)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
    </div>
    <div id="observer-sec" class="item-col">
      <h2 style="margin-top: 10px;">Beobachter</h2>
      <p class="no-items" *ngIf="activeEmployeeGroupObserver.length == 0 && activeEmployeeObserver.length == 0">Keine Beobachter</p>
      <div class="active-item"  [attr.data-isobserver]="true" [attr.data-isgroup]="true" [attr.data-groupid]="group.id" *ngFor="let group of activeEmployeeGroupObserver" style="background: rgba(var(--blueRGB), 0.1)">
        <div>
          <ion-icon name="fa-user-group"></ion-icon>
          <div>{{group?.description}}</div>
        </div>
        <div class="c-bttn" (click)="workerTicket.checkEmployeeGroupe(group.id, true)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
      <div class="active-item"  [attr.data-isobserver]="true" [attr.data-employeeid]="employee.id" *ngFor="let employee of activeEmployeeObserver" style="background: rgba(var(--blueRGB), 0.2)">
        <div>
          <ion-icon name="fa-user"></ion-icon>
          <div>{{employee?.firstName}} {{employee?.lastName}}</div>
        </div>
        <div class="c-bttn" (click)="workerTicket.checkEmployee(employee.id, true)">
          <ion-icon name="fa-x-mark"></ion-icon>
        </div>
      </div>
    </div>
  </div>

  <div id="line"></div>


  <!-- <section id="ticket-workers"> -->
    <div class="search">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
      <input #search type="search" (keyup)="searchEmployee($event)" class="search-input" placeholder="Gruppe, Name..."/>
    </div>

    <p class="no-content" style="font-size: 15px; margin-top: 30px;" *ngIf="notActiveGroupes.length == 0 && notActiveEmployees.length == 0">Keine Gruppen oder Personen</p>

    <h2 *ngIf="notActiveGroupes.length != 0">Gruppen</h2>
    <ion-item *ngFor="let groupe of notActiveGroupes" (click)="workerTicket.checkEmployeeGroupe(groupe.id, false, $event)">
      <ion-icon name="fa-user-group" slot="start"></ion-icon>
      <ion-label>{{groupe?.description}}</ion-label>
      <div slot="end" style="display: flex;">
        <div class="c-bttn" slot="end" title="Bearbeiter" (click)="workerTicket.checkEmployeeGroupe(groupe.id, false, $event)">
          <ion-icon name="fa-hammer"></ion-icon>
        </div>
        <div class="c-bttn" slot="end" title="Beobachter" (click)="workerTicket.checkEmployeeGroupe(groupe.id, true)">
          <ion-icon name="fa-eye"></ion-icon>
        </div>
      </div>
    </ion-item>

    <h2 *ngIf="notActiveEmployees.length != 0">Personen</h2>
    <ion-item *ngFor="let employee of notActiveEmployees" (click)="workerTicket.checkEmployee(employee.id, false)">
      <ion-icon name="fa-user" slot="start"></ion-icon>
      <ion-label>{{employee?.firstName}} {{employee?.lastName}}</ion-label>
      <div slot="end" style="display: flex;">
        <div class="c-bttn" slot="end" title="Bearbeiter" (click)="workerTicket.checkEmployee(employee.id, false)">
          <ion-icon name="fa-hammer"></ion-icon>
        </div>
        <div class="c-bttn" slot="end" title="Beobachter" (click)="workerTicket.checkEmployee(employee.id, true)">
          <ion-icon name="fa-eye"></ion-icon>
        </div>
      </div>
    </ion-item>
  
    <!-- <h2 *ngIf="employeeGroupes.length > 0">Gruppen</h2>
    <div class="worker-item" *ngFor="let groupe of employeeGroupes" (click)="workerTicket.checkEmployeeGroupe(groupe.id)">
      <div class="switch-background"  [ngClass]="{'switch-true': workerTicket.isEmployeeGroupeChecked(groupe.id), 'switch-false': !workerTicket.isEmployeeGroupeChecked(groupe.id)}" style="margin-left: 15px;" >
        <div class="switch-ball"></div>
      </div> 
      <div>{{groupe.description}}</div>
    </div>
    
    <h2 *ngIf="employees.length > 0">Mitarbeiter</h2>
    <div class="worker-item" *ngFor="let employee of employees" (click)="workerTicket.checkEmployee(employee.id)" >
      <div class="switch-background" [ngClass]="{'switch-true': workerTicket.isEmployeeChecked(employee.id), 'switch-false': !workerTicket.isEmployeeChecked(employee.id)}" style="margin-left: 15px;" >
        <div class="switch-ball"></div>
      </div> 
      <div>{{employee.firstName}} {{employee.lastName}}</div>
    </div>
  
    <h3 class="no-content" *ngIf="employeeGroupes.length == 0 && employees.length == 0">Keine Einträge gefunden</h3>
   -->
  <!-- </section> -->
</ion-content>
